document.addEventListener('DOMContentLoaded', function () {
  const yearCheckbox = document.querySelector('#year');
  const yearDropdown = document.querySelector('#yearDropdown');
  const clearFilterBtn = document.querySelector('.clear-filter');
  const allCheckboxes = document.querySelectorAll(
    '.filter-sidebar input[type="checkbox"]'
  );

  if (yearCheckbox && yearDropdown) {
    yearDropdown.classList.add('hidden');

    function populateYearDropdown() {
      const currentYear = new Date().getFullYear();
      yearDropdown.innerHTML = '';

      for (let i = 0; i < 3; i++) {
        const year = currentYear + i;
        const option = document.createElement('option');
        option.value = year;
        option.textContent = year;
        yearDropdown.appendChild(option);
      }
    }

    populateYearDropdown();

    yearCheckbox.addEventListener('change', function () {
      yearDropdown.classList.toggle('hidden', !this.checked);
    });
  }

  if (clearFilterBtn) {
    clearFilterBtn.addEventListener('click', function () {
      allCheckboxes.forEach((cb) => (cb.checked = false));

      if (yearDropdown) {
        yearDropdown.classList.add('hidden');
      }
    });
  }
});
